(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('ri-shipping-estimator')) {
    class RIShippingEstimator extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('[data-ri-shipping-form]');
        this.zip = this.querySelector('[data-ri-shipping-zip]');
        this.state = this.querySelector('[data-ri-shipping-state]');
        this.status = this.querySelector('[data-ri-shipping-status]');
        this.rates = this.querySelector('[data-ri-shipping-rates]');
        this.form.addEventListener('submit',event => this.estimate(event));
      }
      setBusy(busy) { this.form.querySelector('button').disabled = busy; this.zip.disabled = busy; this.state.disabled = busy; }
      async estimate(event) {
        event.preventDefault();
        const zip = this.zip.value.trim();
        const state = this.state.value;
        if (!/^\d{5}(?:-\d{4})?$/.test(zip) || !state) {
          this.status.textContent = this.dataset.invalid;
          this.rates.replaceChildren();
          return;
        }
        this.setBusy(true);
        this.status.textContent = this.dataset.loading;
        this.rates.replaceChildren();
        const root = window.Shopify?.routes?.root || '/';
        const params = new URLSearchParams({'shipping_address[zip]':zip,'shipping_address[country]':'United States','shipping_address[province]':state});
        try {
          const prepare = await fetch(root + 'cart/prepare_shipping_rates.json?' + params,{method:'POST',credentials:'same-origin'});
          if (!prepare.ok) throw new Error('prepare');
          let data = null;
          for (let attempt=0; attempt<10; attempt+=1) {
            await new Promise(resolve => setTimeout(resolve,350));
            const response = await fetch(root + 'cart/async_shipping_rates.json?' + params,{credentials:'same-origin',cache:'no-store'});
            if (!response.ok) throw new Error('rates');
            data = await response.json();
            if (Array.isArray(data.shipping_rates)) break;
          }
          const rates = data?.shipping_rates;
          if (!Array.isArray(rates) || rates.length === 0) {
            this.status.textContent = this.dataset.empty;
            return;
          }
          const currency = window.Shopify?.currency?.active || 'USD';
          const fragment = document.createDocumentFragment();
          rates.forEach(rate => {
            const row = document.createElement('div');
            row.className = 'ri-shipping-estimator__rate';
            const service = document.createElement('span');
            service.textContent = rate.name || rate.presentment_name || '';
            const price = document.createElement('strong');
            price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency}).format(Number(rate.price || 0));
            row.append(service,price);
            fragment.append(row);
          });
          this.rates.replaceChildren(fragment);
          this.status.textContent = '';
        } catch (error) {
          this.status.textContent = this.dataset.error;
        } finally { this.setBusy(false); }
      }
    }
    customElements.define('ri-shipping-estimator',RIShippingEstimator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ri-sales-landing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ri-landing-shop')) {
  class RILandingShop extends HTMLElement {
    connectedCallback() {
      if (this.connection) return;
      this.connection = new AbortController();
      this.grid = this.querySelector('[data-ri-lp-grid]');
      this.status = this.querySelector('[data-ri-lp-status]');
      this.more = this.querySelector('[data-ri-lp-more]');
      this.error = this.querySelector('[data-ri-lp-error]');
      this.selected = 'ALL'; this.limit = 24; this.version = 0;
      this.grid.before(this.status);
      this.querySelector('[data-ri-lp-controls]').hidden = false;
      this.more.hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-ri-lp-size')) this.show(button.dataset.riLpSize, false, true);
        if (button.hasAttribute('data-ri-lp-more')) this.show(this.selected, true);
      }, { signal: this.connection.signal });
      window.addEventListener('popstate', () => this.show(this.readSize(), false), { signal: this.connection.signal });
      if (this.readSize() !== 'ALL' || new URL(location.href).searchParams.get('filter.v.availability') !== '1') this.show(this.readSize(), false);
    }
    readSize() {
      const size = new URL(location.href).searchParams.get('ri_size') || 'ALL';
      return ['ALL','XS','S','M','L','XL','2XL','3XL','OTHER'].includes(size) ? size : 'ALL';
    }
    disconnectedCallback() {
      this.connection?.abort(); this.request?.abort(); this.connection = null;
      this.catalog = null; this.loading = null;
    }
    async getCatalog() {
      if (this.catalog) return this.catalog;
      if (this.loading) return this.loading;
      this.loading = (async () => {
        const cards = new Map(); let page = 1;
        for (let calls = 0; calls < 25; calls++) {
          const url = new URL(this.dataset.collectionUrl, location.origin);
          if (url.origin !== location.origin) throw new Error('Invalid collection');
          url.searchParams.set('section_id', 'ri-size-data');
          url.searchParams.set('filter.v.availability', '1');
          url.searchParams.set('sort_by', this.dataset.sortOrder || 'manual');
          url.searchParams.set('page', String(page));
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          this.request = new AbortController();
          const timer = setTimeout(() => this.request?.abort(), 15000);
          let html;
          try {
            const response = await fetch(url, { credentials: 'same-origin', signal: this.request.signal, cache: 'no-store' });
            if (!response.ok) throw new Error('Collection request failed');
            html = await response.text();
          } finally { clearTimeout(timer); }
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const wrapper = doc.querySelector('[data-ri-catalog-page]');
          if (!wrapper) throw new Error('Missing collection data');
          wrapper.querySelectorAll('.ri-card[data-ri-product-id]').forEach(card => cards.set(card.dataset.riProductId, card));
          const next = Number(wrapper.dataset.riNextPage);
          if (!next) { this.catalog = Array.from(cards.values()); return this.catalog; }
          if (!Number.isInteger(next) || next <= page) throw new Error('Invalid next page');
          page = next;
        }
        throw new Error('Collection too large');
      })();
      try { return await this.loading; } finally { this.loading = null; }
    }
    async show(size, more, updateUrl = false) {
      if (!['ALL','XS','S','M','L','XL','2XL','3XL','OTHER'].includes(size)) return;
      const version = ++this.version;
      const previousCount = this.grid.children.length;
      this.status.textContent = 'Checking available pieces in this collection…';
      this.grid.setAttribute('aria-busy', 'true'); this.more.disabled = true; this.error.hidden = true;
      try {
        const catalog = await this.getCatalog();
        if (!this.isConnected || version !== this.version) return;
        this.limit = more ? this.limit + 24 : 24; this.selected = size;
        if (updateUrl) {
          const url = new URL(location.href);
          if (size === 'ALL') url.searchParams.delete('ri_size'); else url.searchParams.set('ri_size', size);
          if (url.href !== location.href) history.pushState(null, '', url);
        }
        const filtered = catalog.filter(card => size === 'ALL' || card.dataset.riSizes.includes('|' + size + '|'));
        const fragment = document.createDocumentFragment();
        filtered.slice(0, this.limit).forEach(card => {
          const copy = card.cloneNode(true);
          if (size !== 'ALL') {
            const variant = Array.from(copy.querySelectorAll('[data-ri-variant-size]')).find(v => v.dataset.riVariantSize === size);
            if (variant) copy.querySelector('.ri-card__link').href = variant.dataset.riVariantUrl;
          }
          fragment.append(copy);
        });
        this.grid.replaceChildren(fragment);
        this.querySelectorAll('[data-ri-lp-size]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.riLpSize === size)));
        this.querySelector('[data-ri-lp-empty]').hidden = filtered.length !== 0;
        const visible = Math.min(filtered.length, this.limit);
        this.status.textContent = visible + ' of ' + filtered.length + ' available pieces' + (size === 'ALL' ? '.' : ' · ' + (size === 'OTHER' ? this.dataset.otherLabel : size) + '.');
        this.more.hidden = visible >= filtered.length;
        if (more) this.grid.children[previousCount]?.querySelector('a')?.focus({ preventScroll: true });
      } catch (failure) {
        if (version !== this.version || !this.isConnected) return;
        this.status.textContent = 'Selection not refreshed. The previous pieces are still shown.';
        this.error.hidden = false;
      } finally {
        if (version === this.version && this.isConnected) { this.grid.setAttribute('aria-busy','false'); this.more.disabled = false; }
      }
    }
  }
  customElements.define('ri-landing-shop', RILandingShop);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ri-shopfront-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ri-size-shop')) return;
  class RISizeShop extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.grid = this.querySelector('[data-ri-grid]');
      this.status = this.querySelector('[data-ri-status]');
      this.resultsTitle = this.querySelector('[data-ri-results-title]');
      this.more = this.querySelector('[data-ri-more]');
      this.resetButton = this.querySelector('[data-ri-reset]');
      this.featured = Array.from(this.grid.children, node => node.cloneNode(true));
      this.catalog = null;
      this.visibleCount = 12;
      this.generation = 0;
      this.abortEvents = new AbortController();
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-ri-size]');
        if (choice && this.contains(choice)) this.select(choice.dataset.riSize, true);
        if (event.target.closest('[data-ri-more]')) { this.visibleCount += 12; this.render(true); }
        if (event.target.closest('[data-ri-reset]')) this.reset(true);
      }, { signal: this.abortEvents.signal });
      this.readHash = () => {
        const match = location.hash.match(/^#shop-by-size=(XS|S|M|L|XL|2XL|3XL|OTHER|ALL)$/);
        if (match) { this.select(match[1], false); this.scrollIntoView({block:'start'}); }
        else if (this.selected) this.reset(false);
      };
      window.addEventListener('hashchange', this.readHash, { signal: this.abortEvents.signal });
      this.readHash();
    }
    disconnectedCallback() {
      this.abortEvents?.abort();
      this.fetchController?.abort();
      this.generation += 1;
      this.bound = false;
    }
    async loadCatalog() {
      if (this.catalog) return this.catalog;
      if (this.loading) return this.loading;
      const controller = new AbortController();
      this.fetchController = controller;
      const timeout = setTimeout(() => controller.abort(), 30000);
      this.loading = (async () => {
        let page = 1;
        const seen = new Set();
        const cards = new Map();
        while (page) {
          if (seen.has(page) || seen.size >= 100) throw new Error('Catalog pagination could not be completed.');
          seen.add(page);
          const url = new URL(this.dataset.riCatalogUrl, location.origin);
          url.searchParams.set('section_id', this.dataset.riSection);
          url.searchParams.set('filter.v.availability', '1');
          url.searchParams.set('sort_by', 'created-descending');
          url.searchParams.set('page', String(page));
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('Catalog request failed.');
          const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
          const pageRoot = documentPage.querySelector('[data-ri-catalog-page]');
          if (!pageRoot) throw new Error('Catalog response was incomplete.');
          for (const card of pageRoot.querySelectorAll('[data-ri-product-id]')) {
            if (card.dataset.riSizes) cards.set(card.dataset.riProductId, card);
          }
          const next = pageRoot.dataset.riNextPage;
          page = next ? Number(next) : 0;
          if (next && (!Number.isInteger(page) || page < 1)) throw new Error('Invalid catalog page.');
        }
        this.catalog = Array.from(cards.values());
        return this.catalog;
      })();
      try { return await this.loading; }
      finally { clearTimeout(timeout); this.loading = null; }
    }
    async select(size, updateHash) {
      this.selected = size;
      this.grid.removeAttribute('data-ri-balanced');
      this.visibleCount = 12;
      const request = ++this.generation;
      if (updateHash) { const url = new URL(location.href); url.hash = 'shop-by-size=' + size; history.replaceState(null, '', url); }
      this.querySelectorAll('[data-ri-size]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.riSize === size)));
      this.resetButton.hidden = false;
      this.more.hidden = true;
      this.resultsTitle.textContent = size === 'ALL' ? 'All available pieces.' : size === 'OTHER' ? 'Other available sizes.' : size + ' — available pieces.';
      this.grid.replaceChildren();
      this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Checking available pieces…';
      try { await this.loadCatalog(); if (request === this.generation && this.isConnected) this.render(false); }
      catch (error) { if (request === this.generation && this.isConnected) this.status.textContent = 'We could not load sizes. Tap your size to retry, or use Browse all available pieces below.'; }
      finally { if (request === this.generation) this.grid.removeAttribute('aria-busy'); }
    }
    render(focusNew) {
      if (!this.catalog) return;
      const matches = this.selected === 'ALL' ? this.catalog : this.catalog.filter(card => card.dataset.riSizes.includes('|' + this.selected + '|'));
      const before = this.grid.children.length;
      const nodes = matches.slice(0, this.visibleCount).map(node => {
        const clone = node.cloneNode(true);
        const variant = clone.querySelector('[data-ri-variant-size="' + this.selected + '"]');
        if (variant) clone.querySelector('.ri-card__link').setAttribute('href', variant.dataset.riVariantUrl);
        return clone;
      });
      this.grid.replaceChildren(...nodes);
      this.more.hidden = matches.length <= this.visibleCount;
      this.status.textContent = matches.length ? 'Showing ' + Math.min(matches.length, this.visibleCount) + ' of ' + matches.length + ' available pieces. Check measurements on each listing.' : 'No pieces in this size are available right now. Try another size or check back for new finds.';
      if (focusNew) this.grid.children[before]?.querySelector('a')?.focus();
    }
    reset(updateHash) {
      this.generation += 1;
      this.selected = null;
      this.grid.setAttribute('data-ri-balanced', '');
      this.grid.replaceChildren(...this.featured.map(node => node.cloneNode(true)));
      this.grid.removeAttribute('aria-busy');
      this.querySelectorAll('[data-ri-size]').forEach(button => button.setAttribute('aria-pressed', 'false'));
      this.more.hidden = true;
      this.resetButton.hidden = true;
      this.resultsTitle.textContent = 'Featured available pieces.';
      this.status.textContent = 'A few featured pieces. Choose a size to search the full available collection.';
      if (updateHash) { const url = new URL(location.href); url.hash = 'shop-by-size'; history.replaceState(null, '', url); }
    }
  }
  customElements.define('ri-size-shop', RISizeShop);
})();

  } catch(e) { console.error(e); }
})();
})();
